document.addEventListener('DOMContentLoaded', () => {
    const moreLinks = document.querySelectorAll('.js-more-show');
    moreLinks.forEach((item) => {
        item.addEventListener('click', (e) => {
            e.preventDefault();
            const href = item.getAttribute('href') || '';
            document.querySelector(href)?.classList.add('more-show');
        });
    });
});
